import { createContext } from "react";

const SuperAgentCityScreen = createContext<any>(null);

export default SuperAgentCityScreen;
